import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../services/api/axios.config';
import { notify } from '../utils/methods/notification';


const initialState = {
    allRoles: [],
    allPermissionsList: [],
    rolesModule: [],
    allModulesList: [],
    isLoading: false
};


// fetch the all roles data
export const fetchAllRoles = createAsyncThunk(
    'roles/fetchAllRoles',
    async (task_role=false, { rejectWithValue }) => {
        try {
            let url = '/acl/roles';
            if(task_role) url += '?task_role='+task_role 
            const response = await api.get(url);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);
// create a role
export const addRole = createAsyncThunk(
    'roles/addRole',
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post('/acl/roles/create', data);
            notify.success(response.data.message);
            return response.data;
        } catch (error) {
            notify.error(error ?? error.response.message);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// create a role
export const roleRelatedModulesList = createAsyncThunk(
    'roles/roleRelatedModulesList',
    async (rowId, { rejectWithValue }) => {
        try {
            const response = await api.get(`/acl/role/${rowId}/modules`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// create a modules list
export const moduleList = createAsyncThunk(
    'roles/moduleList',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get('/module/list');
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// create a role Update
export const roleUpdate = createAsyncThunk(
    'roles/roleUpdate',
    async (args, { rejectWithValue }) => {
        try {
            const { data, rowId } = args;
            const response = await api.post(`/acl/roles/${rowId}/update`, data);
            notify.success(response.data.message);
            return response.data;
        } catch (error) {
            notify.error(error ?? error.response.message);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// update roles permissions 
export const updateRolesPermissions = createAsyncThunk(
    'roles/updateRolesPermissions',
    async (args, { rejectWithValue }) => {
        try {
            const { data, rowId } = args;
            const response = await api.post(`/acl/roles/${rowId}/permissions/update`, data);
            notify.success(response.data.message);
            return response.data;
        } catch (error) {
            notify.error(error ?? error.response.message);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// fecth a modules list
export const permissionsList = createAsyncThunk(
    'roles/permissionsList',
    async (rowId, { rejectWithValue }) => {
        try {
            const response = await api.get(`/acl/${rowId}/permissions`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// fecth a modules list
export const permissionsListWithUser = createAsyncThunk(
    'roles/permissionsListWithUser',
    async (userId, { rejectWithValue }) => {
        try {
            const response = await api.get(`/acl/user/${userId}/permissions`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// update Roles Permissions With User 
export const updateRolesPermissionsWithUser = createAsyncThunk(
    'roles/updateRolesPermissionsWithUser',
    async (args, { rejectWithValue }) => {
        try {
            const { data, userId } = args;
            const response = await api.put(`/acl/user/${userId}/permissions/update`, data);
            notify.success(response.data.message);
            return response.data;
        } catch (error) {
            notify.error(error ?? error.response.message);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// create a deleteRole 
export const deleteRole = createAsyncThunk(
    'roles/deleteRole',
    async (rowId, { rejectWithValue }) => {
        try {
            const response = await api.delete(`/acl/roles/${rowId}`);
            notify.success(response.data.message);
            return response.data;
        } catch (error) {
            notify.error(error ?? error.response.message);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);




const bmrRolesSlice = createSlice({
    name: 'bmrRoles',
    initialState,
    reducers: {
        clearRolesModule(state) {
            state.rolesModule = []
        },
    },
    extraReducers: (builder) => {
        /// handle fetch all role
        builder
            .addCase(fetchAllRoles.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchAllRoles.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allRoles = action.payload.data
            })
            .addCase(fetchAllRoles.rejected, (state) => {
                state.isLoading = false;
            });
        /// handle add role
        builder
            .addCase(addRole.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(addRole.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(addRole.rejected, (state) => {
                state.isLoading = false;
            });
        /// handle modules list
        builder
            .addCase(moduleList.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(moduleList.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allModulesList = action.payload.data
            })
            .addCase(moduleList.rejected, (state) => {
                state.isLoading = false;
            });
        /// handle roleRelatedModulesList list
        builder
            .addCase(roleRelatedModulesList.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(roleRelatedModulesList.fulfilled, (state, action) => {
                state.isLoading = false;
                state.rolesModule = action.payload.data
            })
            .addCase(roleRelatedModulesList.rejected, (state) => {
                state.isLoading = false;
            });
        /// handle roleUpdate 
        builder
            .addCase(roleUpdate.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(roleUpdate.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(roleUpdate.rejected, (state) => {
                state.isLoading = false;
            });
        /// handle permissionsList 
        builder
            .addCase(permissionsList.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(permissionsList.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allPermissionsList = action.payload.data
            })
            .addCase(permissionsList.rejected, (state) => {
                state.isLoading = false;
            });
        /// handle role  permission update
        builder
            .addCase(updateRolesPermissions.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateRolesPermissions.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(updateRolesPermissions.rejected, (state) => {
                state.isLoading = false;
            });
        /// handle role  permission update
        builder
            .addCase(deleteRole.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deleteRole.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(deleteRole.rejected, (state) => {
                state.isLoading = false;
            });
        /// handle fetch permissionsListWithUser
        builder
            .addCase(permissionsListWithUser.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(permissionsListWithUser.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allPermissionsList = action.payload.data
            })
            .addCase(permissionsListWithUser.rejected, (state) => {
                state.isLoading = false;
            });
        /// handle update Roles Permissions With User
        builder
            .addCase(updateRolesPermissionsWithUser.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateRolesPermissionsWithUser.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(updateRolesPermissionsWithUser.rejected, (state) => {
                state.isLoading = false;
            });
    }, 
});

export const { clearRolesModule } = bmrRolesSlice.actions

export const selectBmrRolesLoading = (state) => state.bmrRoles.isLoading;
export const selectAllModulesList = (state) => state.bmrRoles.allModulesList;
export const selectAllRoles = (state) => state.bmrRoles.allRoles;
export const selectRolesModule = (state) => state.bmrRoles.rolesModule
export const selectPermissionsList = (state) => state.bmrRoles.allPermissionsList



export default bmrRolesSlice.reducer;
